import { PasswordInput, type PasswordInputProps } from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldPasswordInputProps
  extends CommonFormFieldItemProps, PasswordInputProps {
  type: "password";
}

function FormFieldPasswordInput({
  helpText,
  highlight,
  isBetaFeature,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldPasswordInputProps) {
  return (
    <PasswordInput
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames("FormFieldTextInput", fieldSpecificProps.className)}
      defaultValue={undefined}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      rightSection={
        <FormFieldRightSection
          rightSection={fieldSpecificProps.rightSection}
          warned={warned}
        />
      }
      value={fieldSpecificProps.value || fieldSpecificProps.defaultValue || ""}
    />
  );
}

export { FormFieldPasswordInput, FormFieldPasswordInputProps };
